import request from "@/utils/request";

export async function checkUsername(email) {
  return await request.post("/check-customer", {
    email,
  });
}

export async function loginByUsername(email, password) {
  return await request.post("/authentication-token", {
    email,
    password,
  });
}

export async function checkSession() {
  return await request.post("/authentication/check", {
    token: "me",
  });
}

export async function logout(data = {}) {
  return await request.post("/authentication/logout", data);
}
